import React from 'react';
import { Box, Table, Text } from '@nimbus-ds/components';
import { useTranslationWithPrefix } from 'commons/utils';
import TransactionsFilter from '../TransactionsFilter';
import { HomeTableRows } from './HomeTableRows';

function HomeTableDesktopSkeleton(): JSX.Element {
  const { t } = useTranslationWithPrefix('home.homeTable');

  const headers = [
    t('headers.orders'),
    t('headers.date'),
    t('headers.client'),
    t('headers.value'),
    t('headers.status'),
  ].map((header, index) => {
    return (
      <Table.Cell backgroundColor="neutral-surface" key={index}>
        <Text fontWeight="medium" color="neutral-textHigh">
          {header}
        </Text>
      </Table.Cell>
    );
  });

  const renderDataTable = () => (
    <Table>
      <Table.Head>{headers}</Table.Head>
      <HomeTableRows.Skeleton />
    </Table>
  );

  return (
    <Box display="flex" flexDirection="column" alignItems="stretch" gap="4">
      <Text.Skeleton />
      <TransactionsFilter.Skeleton />
      {renderDataTable()}
    </Box>
  );
}

export default HomeTableDesktopSkeleton;
